import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Clock, Mail, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const ClinicRegistrationSuccessPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-lg mx-auto text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-[#2ECC71]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-10 w-10 text-[#2ECC71]" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Registration Submitted!
          </h1>
          <p className="text-gray-600 mb-8">
            Thank you for registering your clinic on VietClinics. Your application is now being reviewed.
          </p>

          {/* What's Next */}
          <div className="bg-white rounded-2xl p-6 shadow-sm text-left mb-8">
            <h2 className="font-bold text-gray-900 mb-4">What happens next?</h2>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#1FA7A1]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="font-bold text-[#1FA7A1] text-sm">1</span>
                </div>
                <div>
                  <p className="font-medium text-gray-900">Review Process</p>
                  <p className="text-sm text-gray-600">Our team will verify your clinic information within 24-48 hours.</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#1FA7A1]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="font-bold text-[#1FA7A1] text-sm">2</span>
                </div>
                <div>
                  <p className="font-medium text-gray-900">Email Confirmation</p>
                  <p className="text-sm text-gray-600">You'll receive an email once your clinic is approved.</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#1FA7A1]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="font-bold text-[#1FA7A1] text-sm">3</span>
                </div>
                <div>
                  <p className="font-medium text-gray-900">Go Live</p>
                  <p className="text-sm text-gray-600">Your clinic will be visible to patients and you can start receiving bookings!</p>
                </div>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="bg-white rounded-xl p-4 shadow-sm">
              <Clock className="h-6 w-6 text-[#1FA7A1] mb-2" />
              <p className="text-sm text-gray-600">Review Time</p>
              <p className="font-bold text-gray-900">24-48 hours</p>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm">
              <Mail className="h-6 w-6 text-[#1FA7A1] mb-2" />
              <p className="text-sm text-gray-600">Questions?</p>
              <p className="font-bold text-gray-900">clinics@vietclinics.com</p>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Link to="/">
              <Button className="w-full bg-[#1FA7A1] hover:bg-[#178f8a]">
                Back to Homepage
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Link>
            <Link to="/pricing">
              <Button variant="outline" className="w-full">
                For Clinics
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ClinicRegistrationSuccessPage;
